// accountants/fuel-detail
import React, { useCallback, useState } from 'react';
import View from 'src/pages/accountants/fuels/detail';
import AppRender from 'src/routes/app-render';
import { useForm } from 'src/hooks/use-form';
import { fuelsApi } from 'src/api/fuels/vm-view';

const Page = () => {
  const { handleNavigate, itemNavigate } = useForm();
  
  const [data, setData] = useState();
  const fetchData = useCallback(async () => {
    if(itemNavigate){
      fuelsApi.getDetail(
        itemNavigate, true,
        (result) => {
          setData(result);
        },
      );
    }
  }, []);

  return (
    <AppRender apiCall={fetchData}>
      {data && <View onNavigate={handleNavigate} item={data} />}
    </AppRender>
  );
};

export default Page;
